import type { ContactLocale } from "./types";

export const CONTACT_PATH = "/help/contact";
export const MESSAGES_PATH = "/admin/messages";
export const SUPPORT_EMAIL = "support@connectyid.org";
/** The one support number for everyone (plan D4). The WhatsApp and Text links are built from it. */
export const SUPPORT_PHONE = "575-741-0444";
export const MESSAGE_LIMIT = 2000;
export const COUNTER_FROM = 1800;

const digits = SUPPORT_PHONE.replace(/\D/g, "");
export const callHref = `tel:${digits}`;
export const textHref = `sms:${digits}`;
export const whatsappHref = `https://wa.me/${digits}`;

export const localeOf = (lang: string): ContactLocale => (lang === "he" || lang === "fr" ? lang : "en");

/** The Contact us address, keeping the owner's preview prefix (/next/…). `topic` opens the form with that topic chosen. */
export const contactHref = (prefix = "", topic?: string) => `${prefix}${CONTACT_PATH}${topic ? `?topic=${topic}` : ""}`;
